import { GET_ORDER_LIST, FETCH_DEFAULT_QUOTES } from '../@types/thunk.types'
import Http from '../../helpers/Http'
import { closeLoader, openLoader } from '../Loader'
import { toast } from 'react-toastify'
import { orderActionTypes } from './index'
import { FETCH_ORDER_LIST, SET_DEFAULT_QUOTES } from '../@types/action.types'

const buildDateRangeParams = (dateRange) => {
    if (!dateRange) return {}
    const isCustom = dateRange.type === 'CUSTOM'
    return {
        dateRangeType: dateRange.type || 'ALL_TIME',
        startDate: isCustom ? dateRange.fromDate : undefined,
        endDate: isCustom ? dateRange.toDate : undefined
    }
}

const buildDateRangeQueryString = (dateRange) => {
    if (!dateRange) return ''
    const isCustom = dateRange.type === 'CUSTOM'
    let str = `&dateRangeType=${dateRange.type || 'ALL_TIME'}`
    if (isCustom && dateRange.fromDate)
        str += `&startDate=${dateRange.fromDate}`
    if (isCustom && dateRange.toDate) str += `&endDate=${dateRange.toDate}`
    return str
}

const OrderThunks = {
    [GET_ORDER_LIST]:
        (params, merge, activeTab, dateRange) => async (dispatch, getState) => {
            const countParams = buildDateRangeParams(dateRange)
            const listParams = params + buildDateRangeQueryString(dateRange)
            await Http.GET('statusWiseCount', countParams).then(
                async (countResponse) => {
                    await Http.GET('getOrderList', listParams).then(
                        (response) => {
                            dispatch({
                                type: orderActionTypes[FETCH_ORDER_LIST],
                                payload: {
                                    response: response.data,
                                    merge: merge,
                                    activeTab: activeTab,
                                    countResponse: countResponse.data
                                }
                            })
                        }
                    )
                }
            )
        },
    [FETCH_DEFAULT_QUOTES]: (ids) => async (dispatch, getState) => {
        try {
            dispatch(openLoader())
            const response = await Http.POST('fetchDefaultQuotes', ids)
            if (response) {
                dispatch({
                    type: orderActionTypes[SET_DEFAULT_QUOTES],
                    payload: response.data
                })
                dispatch(closeLoader())
                return getState()?.orders?.defaultQuotes
            }
        } catch (error) {
            dispatch(closeLoader())
            toast.error(error.response.data.message)
        }
    }
}

export default OrderThunks
